<mat-sidenav-container class="client-container">
  <mat-sidenav
    style="width: 90%"
    class="main row marketing_details"
    #sidenav
    position="end"
    [opened]="clientMarketingDetailsSheetActive"
    disableClose
  >
    <div class="sliding-sheet-header">
      <h4>Client Marketing Details</h4>
      <button type="button" (click)="closeMarketingEffectivenessSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="client-header">
      <div class="container">
        <div class="row mt-2">
          <div class="client-name">
            <h3 class="mb-1">{{ clientDetails?.fullName }}</h3>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-4 col-sm-6 col-12 mb-2">
            <p class="client-dtls mb-2">
              <i _ngcontent-rfs-c349="" class="material-icons">email </i>{{ clientDetails?.email }}
            </p>
            <p class="client-dtls mb-2" *ngIf="clientDetails.phone">
              <i _ngcontent-rfs-c349="" class="material-icons">phone </i>{{ clientDetails?.phone }}
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-12">
            <p class="mb-1"><b>Lead Score :</b> {{ clientDetails?.totalActivityScore | number: '1.0-0' }}</p>
            <p class="mb-1"><b>Lead Type :</b> {{ clientDetails.leadType }}</p>
          </div>

          <div class="col-md-4 col-sm-6 col-12">
            <p class="mb-2">
              <b>Interested Areas : </b>
              <span *ngIf="clientDetails.interestedAreas && clientDetails.interestedAreas.length">
                <ng-container
                  *ngFor="let area of clientDetails.interestedAreas | slice: 0:clientDetails.interestedAreas.length - 1"
                >
                  <span *ngIf="$any(area).locality && $any(area).state"
                    >{{ $any(area).locality }} , {{ $any(area).state }}</span
                  >
                </ng-container>
                <ng-container *ngIf="clientDetails.interestedAreas[clientDetails.interestedAreas.length - 1].locality">
                  {{ clientDetails.interestedAreas[clientDetails.interestedAreas.length - 1].locality }},
                  {{ clientDetails.interestedAreas[clientDetails.interestedAreas.length - 1].state }}
                </ng-container>
                <ng-container *ngIf="!clientDetails.interestedAreas[clientDetails.interestedAreas.length - 1].locality">
                  <b>--</b>
                </ng-container>
              </span>
            </p>
            <p class="mb-1">
              <b>Lead Status :</b>
              {{
                appState?.companyInfoValue &&
                  appState.companyInfoValue[clientDetails.leadType + 'LeadCategory'] &&
                  appState.companyInfoValue[clientDetails.leadType + 'LeadCategory'][clientDetails.leadStatus]
                    .displayText | titlecase
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="clnt_cnt_dtls container">
      <div class="row">
        <div class="col-lg-12 mt-5">
          <mat-expansion-panel class="mb-3" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h5 class="my-3 headWrap note-head">Marketing Emails</h5>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-lg-12">
                <div class="">
                  <div class="table-responsive table_wrap" #clientListContainer>
                    <table
                      mat-table
                      [dataSource]="dataSource"
                      class="w-100"
                      matSort
                      matSortActive="lastActivityDate"
                      matSortDirection="desc"
                    >
                      <ng-container matColumnDef="time">
                        <th mat-header-cell *matHeaderCellDef>Time/Created Date</th>
                        <td mat-cell *matCellDef="let element">{{ element.insertedDate | date: 'MMM d, h:mm a' }}</td>
                      </ng-container>
                      <ng-container matColumnDef="emailStatus">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>Email Status</th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="element.readCount > 0 && element.sentCount == 1">Viewed</span>
                          <span *ngIf="element.readCount == 0 && element.sentCount == 1">Sent</span>
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="noOfListings">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>No of Listings</th>
                        <td mat-cell *matCellDef="let element">
                          {{
                            element.numberOfListings == 0 || !element.numberOfListings ? '-' : element.numberOfListings
                          }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="noOfClickThrough">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>No of Click Throughs</th>
                        <td mat-cell *matCellDef="let element">
                          {{
                            element.numberOfListings == 0 || !element.numberOfListings
                              ? '-'
                              : element.noOfClicks == 0 || !element.noOfClicks
                              ? '-'
                              : element.noOfClicks
                          }}
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="tableColumnList; sticky: true"></tr>
                      <tr
                        mat-row
                        *matRowDef="let row; columns: tableColumnList"
                        (click)="openPropertyDetailsSheet(row)"
                      ></tr>
                    </table>
                  </div>

                  <div class="flex_center w-100" *ngIf="!isDataLoading && !investorUsersCount">
                    <div class="notFound text-center noData">
                      <div>
                        <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                        <h4>No users data found</h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <mat-paginator
              [pageSizeOptions]="[10, 20]"
              [length]="marketingEmailCount"
              [pageSize]="pageSize"
              [pageIndex]="pageIndex"
              (page)="onPageChange($event)"
              class="d-inline-block m-wdh w-100"
              showFirstLastButtons
            >
            </mat-paginator>
          </mat-expansion-panel>
        </div>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
